import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../appSettings';

import { ActivatedRoute } from '@angular/router';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form
} from '@angular/forms';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ICustomer } from '../interfaces/customer';
import { CustomerService } from '../services/customer.service';
import { HelperService } from '../services/helper.service';
import { NavigationService } from '../services/navigation-service.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],
  host: { 'class': 'wrapper-customer' },
  encapsulation: ViewEncapsulation.None
})
export class CustomerComponent implements OnInit {

  public loading: boolean = false
  public loadingCEP: boolean = false
  public changeDetail: boolean = false

  public tab: string = 'dados'

  private _id: number
  public customer: ICustomer

  public customerFrm: FormGroup

  public nome: FormControl
  public telefone: FormControl
  public email: FormControl
  public cpf: FormControl

  public enderecos: FormArray

  public m_cpf_cnpj: string
  public m_telefone: string

  constructor(private _route: ActivatedRoute, private _customerService: CustomerService, private _helperService: HelperService, private navigation: NavigationService) { }

  ngOnInit(): void {
    this.createFormControls()
    this.createForm()

    this.customer = {
      idusuario: 0
    }

    this.loading = true
    this._route.params.subscribe(data => {
      //console.log(data['codbarra'])
      if (data['id'] !== undefined) {
        this._id = data['id']
        this.getCustomerID(data['id'])
      } else {
        this.loading = false
      }
    })
  }

  createFormControls() {
    this.nome = new FormControl('', [
      Validators.required,
    ])
    this.telefone = new FormControl(null)

    this.cpf = new FormControl('', [
      Validators.required,
    ])
    this.email = new FormControl('', [
      Validators.required,
      Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")
    ])

    this.enderecos = new FormArray([])

  }

  createForm() {
    this.customerFrm = new FormGroup({
      nome: this.nome,
      telefone: this.telefone,
      cpf: this.cpf,
      email: this.email,
      enderecos: this.enderecos,
    })
  }

  onTabClick(t) {
    this.tab = t
  }

  onBack() {
    this.navigation.back()
  }

  cpfcnpjmask(ev) {
    const value = this.cpf.value
    if(value.length <= 11) {
      this.m_cpf_cnpj = '000.000.000-009'
    }
    else {
      this.m_cpf_cnpj = '00.000.000/0000-00'
    }

    this.onChangeDetail()
  }

  telefonemask(ev) {
    const value = this.telefone.value
    if(value.length <= 10) {
      this.m_telefone = '(00) 0000-00009'
    }
    else {
      this.m_telefone = '(00) 00000-0000'
    }

    this.onChangeDetail()
  }

  onCEPChange(i) {
    let fg = <FormGroup>this.enderecos.controls[i]

    if (fg){
      const value = fg.controls.cep.value
      if(value.length >= 8) {
        this.loadingCEP = true
        this._helperService.findCEP(value).subscribe(res => {
          if (res.success) {
            /*
            bairro: "Aparecida"
            cep: "94850-230"
            complemento: ""
            endereco_completo: "Rua Carlos Barbosa - Aparecida, Alvorada - RS"
            latitude: "-30.0200228000"
            localidade: "Alvorada"
            logradouro: "Rua Carlos Barbosa"
            longitude: "-51.0850336000"
            nome_bairro: "Aparecida"
            sigla: "RS"
            uf: "RS"
            */
           if (res.localidades.length > 0) {
            let localidade = res.localidades[0]
            fg.controls.logradouro.setValue(localidade['logradouro'])
            fg.controls.complemento.setValue(localidade['complemento'])
            fg.controls.bairro.setValue(localidade['bairro'])
            fg.controls.cidade.setValue(localidade['localidade'])
            fg.controls.uf.setValue(localidade['uf'])
           }
		  } else {
			  Swal.fire("Ops!", "Não foi possível encontrar as informações para o CEP informado", "error")
		  }

		  this.loadingCEP = false
        })
      }
    }
  }

  public addAddress() {
    this.enderecos.push(
      new FormGroup({
        idendereco: new FormControl(null),
        cep: new FormControl(null),
        logradouro: new FormControl(''),
        numero: new FormControl(null),
        complemento: new FormControl(''),
        bairro: new FormControl(''),
        cidade: new FormControl(''),
        uf: new FormControl(''),
        padrao: new FormControl('')
      })
    )
  }

  deleteAddress(i) {
    Swal.fire({
      title: 'Você deseja excluir esse endereço?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.enderecos.controls.splice(i,1)
      }
    })
  }

  onCancelRegister() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loading = true
        this.getCustomerID(this._id)
      }
    })
  }

  getCustomerID(id: number) : void {
    this.changeDetail = false
    this._customerService.getCustomerID(id).subscribe(res => {
      this.resCustomer(res)
    })
  }

  resCustomer(res) {
    //console.log(res)
    if (res['success'] == true) {
      this.customer = res;

      this._id = this.customer['idusuario']

      this.nome.setValue(this.customer.nome)
      this.telefone.setValue(this.customer.telefone)
      this.cpf.setValue(this.customer.cpf)
      this.email.setValue(this.customer.email)

      this.enderecos.clear()

      for(let i in this.customer.addresses) {

        let addresses = this.customer.addresses[i]

        //`idendereco`, `cep`, `logradouro`, `numero`, `complemento`, `bairro`, `idusuario`, `cidade`, `uf`, `padrao`, `latitude`, `longitude`, `flag_fraude`
        let frmEndereco = new FormGroup({
          idendereco: new FormControl(addresses['idendereco']),
          cep: new FormControl(addresses['cep']),
          logradouro: new FormControl(addresses['logradouro']),
          numero: new FormControl(addresses['numero']),
          complemento: new FormControl(addresses['complemento']),
          bairro: new FormControl(addresses['bairro']),
          cidade: new FormControl(addresses['cidade']),
          uf: new FormControl(addresses['uf']),
          padrao: new FormControl(addresses['padrao'])
        })

        this.enderecos.push(frmEndereco)
      }

      if (this.customer.edita) {

      } else {
        this.customerFrm.disable()
      }

    }

    this.loading = false
  }

  onChangeDetail() {
    this.changeDetail = true
  }

  saveError() {
    Swal.fire("Ops!", "Ocorreu um erro ao tentar salvar.", "error")
  }

  saveComplete() {
    Swal.fire("Salvo!", "O cliente foi salvo", "success")
  }

  saving() {
    Swal.fire({
      title: "Salvando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  customerValid() {
    let has = true

    let msg = []

    if ((this.nome.invalid && (this.nome.dirty || this.nome.touched)) || this.nome.value == '' || this.nome.value == undefined  || this.nome.value == null) {
      msg.push('Você precisa preencher o nome do cliente!');
      has = false
    }


    if ((this.cpf.invalid && (this.cpf.dirty || this.cpf.touched)) || this.cpf.value == '' || this.cpf.value == undefined || this.cpf.value == null) {
      msg.push('Você precisa preencher o CPF / CNPJ do cliente!');
      has = false
    }


    if ((this.email.invalid && (this.email.dirty || this.email.touched)) || this.email.value == '' || this.email.value == undefined || this.email.value == null) {
      msg.push('Você precisa preencher o e-mail do cliente!');
      has = false
    }

    /*
    for(let i in this.categories.controls) {
      let fGroup = <FormGroup>this.categories.controls[i];

      let categoria = <FormControl>fGroup.controls.categoria;
      if ((categoria.invalid && (categoria.dirty || categoria.touched)) || categoria.value == '' || categoria.value == null) {
        msg.push('Você precisa selecionar a categoria!');
        has = false
      }

      let subcategorias = <FormArray>fGroup.controls.subcategorias;
      for(let j in subcategorias.controls) {
        let fsGroup = <FormGroup>subcategorias.controls[j];

        let subcategoria = <FormControl>fsGroup.controls.subcategoria;
        if ((subcategoria.invalid && (subcategoria.dirty || subcategoria.touched)) || subcategoria.value == '' || subcategoria.value == null) {
          msg.push('Você precisa selecionar a subcategoria!');
          has = false
        }
      }
    }
    */

    if (msg.length > 0) {
      Swal.fire("Ops!", msg.join("<br>"), "error");
    }

    return has
  }

  onSubmit() {
    if (this.customerValid()) {

      let data = {
        nome: this.nome.value,
        telefone: this.telefone.value,
        email: this.email.value,
        cpf: this.cpf.value
      }

      let address = []
      this.enderecos.controls.forEach((c) => {
        let fg = <FormGroup>c

        address.push({
          idendereco: fg.controls.idendereco.value,
          cep: fg.controls.cep.value,
          logradouro: fg.controls.logradouro.value,
          numero: fg.controls.numero.value,
          complemento: fg.controls.complemento.value,
          bairro: fg.controls.bairro.value,
          cidade: fg.controls.cidade.value,
          uf: fg.controls.uf.value,
          padrao: fg.controls.padrao.value
        })
      })

      data['address'] = address;

      //console.log(data)

      this.saving()

      this.storeCustomer(data)

    }
    return null

  }

  storeCustomer(data) {
    this._customerService.store(this.customer.idusuario, data).subscribe(res => {
      if (res['success']) {

        /**
         *
         * update address
         *
         */
        this.resCustomer(res)


        this.saveComplete()

      } else {
        this.saveError()
      }

    }, error => {
      this.saveError()
    })
  }

}
